import { render, staticRenderFns } from "./footer-bottom.vue?vue&type=template&id=49039375&scoped=true"
var script = {}
import style0 from "./footer-bottom.vue?vue&type=style&index=0&id=49039375&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49039375",
  null
  
)

export default component.exports